import { useContext } from "react";
import { NotificationContext, NotificationContextType } from "..";

export const useNotification = (): NotificationContextType => {
    const { notification: data, addNotification, removeNotification } = useContext(NotificationContext);

    return { notification: data, addNotification, removeNotification };
};
